import { render, staticRenderFns } from "./FluxoServicoFunerario.vue?vue&type=template&id=4f30cfa8&scoped=true"
import script from "./FluxoServicoFunerario.vue?vue&type=script&lang=js"
export * from "./FluxoServicoFunerario.vue?vue&type=script&lang=js"
import style0 from "./FluxoServicoFunerario.vue?vue&type=style&index=0&id=4f30cfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f30cfa8",
  null
  
)

export default component.exports